define('shoptheme/components/plugin/multiline-placeholder',[
    "jquery",
    "cartware/components/_base",
    "cartware/jquery/bem"
], function(
        $,
        Component,
        BEM
) {
    return Component.create({
        block:			null,
        textarea:			null,
        submit:		null,
        name:		null,
        summary:		null,

        $init: function () {
            this.block = BEM.block("review-form");
            this.textarea = this.block.getElements("text");
            this.name = this.block.getElements("name");
            this.summary = this.block.getElements("summary");

            var $textarea = this.textarea,
                    text  = $textarea.attr('placeholder'),
                    match = /\r|\n/.exec(text),
                    $fieldName = this.name,
                    $fieldSummary = this.summary;

            if (! match) {
                return;
            }

            $textarea.attr('placeholder', '')
                    .data('placeholder', text)
                    .addClass('active-placeholder')
                    .val(text);

            $textarea.on('focus', function() {
                var currentVal = $textarea.val();
                if ($textarea.data('placeholder') === currentVal) {
                    $textarea.data('placeholder', currentVal)
                            .val('')
                            .removeClass('active-placeholder');
                }
            });

            $textarea.on('blur', function() {
                if ($textarea.val() === '') {
                    $textarea.val($textarea.data('placeholder'))
                            .addClass('active-placeholder');
                }
            });

            //clear value of textarea before validation
            this.submit = this.block.getElements("submit");
            this.submit.click(function() {
               if ($fieldName.val() != '' && $fieldSummary.val() != '' && $textarea.val() == $textarea.data('placeholder')) {
                   $textarea.focus();
               }
            });
        }
    });
});
